/* unplugin-vue-components disabled */import { render } from "./layout-main-tag.vue?vue&type=template&id=8e606370&scoped=true"
import script from "./layout-main-tag.vue?vue&type=script&lang=js"
export * from "./layout-main-tag.vue?vue&type=script&lang=js"

import "./layout-main-tag.vue?vue&type=style&index=0&id=8e606370&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/e-bike/e-bike-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e606370"]])

export default __exports__